import Attention from '@public/next/img/attention.svg';

import styles from './ErrorUserLk.module.scss';

export const ErrorUserLk = () => {
  return (
    <div className={styles.WrapperError}>
      <Attention width={60} height={64} />
      <div>
        <div className={styles.Text}>Не удаётся загрузить данные.</div>
        <div className={styles.Desr}>Попробуйте ещё через несколько минут.</div>
      </div>
    </div>
  );
};
